import { render, staticRenderFns } from "./labelManage.vue?vue&type=template&id=53c97b2b&scoped=true&"
import script from "./labelManage.vue?vue&type=script&lang=js&"
export * from "./labelManage.vue?vue&type=script&lang=js&"
import style0 from "./labelManage.vue?vue&type=style&index=0&id=53c97b2b&prod&scoped=true&lang=css&"
import style1 from "./labelManage.vue?vue&type=style&index=1&id=53c97b2b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c97b2b",
  null
  
)

export default component.exports